import React from 'react';
import { Link } from 'gatsby';
import Dropdown from './dropdown';

const Header = () => (
  <header className="header">
    <div className="header-content">
      <div className="header-introduction">
        <a href="/" className="header__title__home-link">
          <h1 className="header__title">
            Digital Barometer of Innovation on Nanotechnology
          </h1>
        </a>
      </div>
      <div className="header-options">
        <Link to="/indicators" className="header-options__link">Indicators</Link>
        <Dropdown />
        <Link to="/publications" className="header-options__link">Scientific Publications</Link>
        <Link to="/sites" className="header-options__link">Other Sites</Link>
        <Link to="/good-practices" className="header-options__link">Good practices</Link>
      </div>
    </div>
  </header>
);
export default Header;
